var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgGaleria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_galeria") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-3518.000000, -430.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 5.13
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_galeria",
    transform: "translate(3521.000000, 433.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79,7.82100008 C79,2.25150021 76.4720019,0 70.1915018,0 L54.2334982,0 C47.9529981,0 45.425,2.25150021 45.425,7.82100008 L45.425,25.7145009 C45.425,31.3235007 47.9529981,33.5354991 54.2334982,33.5354991 L70.1915018,33.5354991 C76.4720019,33.5749991 79,31.3235017 79,25.7540018 L79,7.82100008 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,54.2334982 C79,47.9529981 76.4720019,45.425 70.1915018,45.425 L54.2334982,45.425 C47.9529981,45.425 45.425,47.9529981 45.425,54.2334982 L45.425,70.1915018 C45.425,76.4720019 47.9529981,79 54.2334982,79 L70.1915018,79 C76.4720019,79 79,76.4720019 79,70.1915018 L79,54.2334982 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.575,7.82100008 C33.575,2.25150021 31.0470019,0 24.7665018,0 L8.80850008,0 C2.52799994,0 0,2.25150021 0,7.82100008 L0,25.7145009 C0,31.3235007 2.52799994,33.5354991 8.80850008,33.5354991 L24.7665018,33.5354991 C31.0470019,33.5749991 33.575,31.3235017 33.575,25.7540018 L33.575,7.82100008 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.575,54.2334982 C33.575,47.9529981 31.0470019,45.425 24.7665018,45.425 L8.80850008,45.425 C2.52799994,45.425 0,47.9529981 0,54.2334982 L0,70.1915018 C0,76.4720019 2.52799994,79 8.80850008,79 L24.7665018,79 C31.0470019,79 33.575,76.4720019 33.575,70.1915018 L33.575,54.2334982 Z",
    id: "Vector"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgGaleria);
export default __webpack_public_path__ + "static/media/svg_galeria.0bcbc38cef45dbe66259dd099cc16de0.svg";
export { ForwardRef as ReactComponent };